/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCurrentUserAvailableOrganisation } from './InternalApiCurrentUserAvailableOrganisation';
import {
    InternalApiCurrentUserAvailableOrganisationFromJSON,
    InternalApiCurrentUserAvailableOrganisationFromJSONTyped,
    InternalApiCurrentUserAvailableOrganisationToJSON,
    InternalApiCurrentUserAvailableOrganisationToJSONTyped,
} from './InternalApiCurrentUserAvailableOrganisation';
import type { InternalApiCurrentUserOrganisation } from './InternalApiCurrentUserOrganisation';
import {
    InternalApiCurrentUserOrganisationFromJSON,
    InternalApiCurrentUserOrganisationFromJSONTyped,
    InternalApiCurrentUserOrganisationToJSON,
    InternalApiCurrentUserOrganisationToJSONTyped,
} from './InternalApiCurrentUserOrganisation';
import type { InternalApiCurrentUserIntercomConfig } from './InternalApiCurrentUserIntercomConfig';
import {
    InternalApiCurrentUserIntercomConfigFromJSON,
    InternalApiCurrentUserIntercomConfigFromJSONTyped,
    InternalApiCurrentUserIntercomConfigToJSON,
    InternalApiCurrentUserIntercomConfigToJSONTyped,
} from './InternalApiCurrentUserIntercomConfig';

/**
 * 
 * @export
 * @interface InternalApiCurrentUserInfo
 */
export interface InternalApiCurrentUserInfo {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCurrentUserInfo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCurrentUserInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCurrentUserInfo
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCurrentUserInfo
     */
    roles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCurrentUserInfo
     */
    permissions: Array<string>;
    /**
     * 
     * @type {InternalApiCurrentUserIntercomConfig}
     * @memberof InternalApiCurrentUserInfo
     */
    intercomConfig?: InternalApiCurrentUserIntercomConfig;
    /**
     * 
     * @type {InternalApiCurrentUserOrganisation}
     * @memberof InternalApiCurrentUserInfo
     */
    currentOrganisation?: InternalApiCurrentUserOrganisation;
    /**
     * 
     * @type {Array<InternalApiCurrentUserAvailableOrganisation>}
     * @memberof InternalApiCurrentUserInfo
     */
    readonly availableOrganisations: Array<InternalApiCurrentUserAvailableOrganisation>;
}

/**
 * Check if a given object implements the InternalApiCurrentUserInfo interface.
 */
export function instanceOfInternalApiCurrentUserInfo(value: object): value is InternalApiCurrentUserInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('availableOrganisations' in value) || value['availableOrganisations'] === undefined) return false;
    return true;
}

export function InternalApiCurrentUserInfoFromJSON(json: any): InternalApiCurrentUserInfo {
    return InternalApiCurrentUserInfoFromJSONTyped(json, false);
}

export function InternalApiCurrentUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCurrentUserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'name': json['name'],
        'roles': json['roles'],
        'permissions': json['permissions'],
        'intercomConfig': json['intercomConfig'] == null ? undefined : InternalApiCurrentUserIntercomConfigFromJSON(json['intercomConfig']),
        'currentOrganisation': json['currentOrganisation'] == null ? undefined : InternalApiCurrentUserOrganisationFromJSON(json['currentOrganisation']),
        'availableOrganisations': ((json['availableOrganisations'] as Array<any>).map(InternalApiCurrentUserAvailableOrganisationFromJSON)),
    };
}

export function InternalApiCurrentUserInfoToJSON(json: any): InternalApiCurrentUserInfo {
    return InternalApiCurrentUserInfoToJSONTyped(json, false);
}

export function InternalApiCurrentUserInfoToJSONTyped(value?: Omit<InternalApiCurrentUserInfo, 'availableOrganisations'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
        'roles': value['roles'],
        'permissions': value['permissions'],
        'intercomConfig': InternalApiCurrentUserIntercomConfigToJSON(value['intercomConfig']),
        'currentOrganisation': InternalApiCurrentUserOrganisationToJSON(value['currentOrganisation']),
    };
}

